import { render } from "./update-dispatch.vue?vue&type=template&id=bf5cb248&scoped=true&ts=true"
import script from "./update-dispatch.vue?vue&type=script&lang=ts"
export * from "./update-dispatch.vue?vue&type=script&lang=ts"

import "./update-dispatch.vue?vue&type=style&index=0&id=bf5cb248&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5cb248"]])

export default __exports__